export enum ProjectOAuth2GooglePrompt {
    None = 'none',
    Consent = 'consent',
    SelectAccount = 'select_account',
}
